const clinic = {
    getlist: 'clinic/getlist',
    add: 'clinic/add',
    update: 'clinic/update',
    remove: 'clinic/remove',
    get: 'clinic/get',
    getall: 'clinic/getall',
    clearcache: 'clinic/clear-cache',
}
export default clinic
